/* eslint-disable */
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "../../Assets/css/dragDropArea.css";

const DragAndDropUpload = ({ debouncedIsDragOver }) => {
  return (
    <>
      {debouncedIsDragOver && (
        <div className="drag-drop-container">
          <div className="drag-drop-wrapper">
            <div className="drag-drop-content">
              <CloudUploadIcon className="drag-drop-icon" />
              <p className="drag-drop-text">Drop File Here to Upload</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DragAndDropUpload;
